// Wrapper around the actual Stripe <*Element>, so that it can be used as `inputComponent`
// for Material UI's <Input>. Also adds some styling.

import * as React from 'react'
import { WithStyles } from '@material-ui/core'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import createStyles from '@material-ui/core/styles/createStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  ReactStripeElements
} from 'react-stripe-elements'

interface IStripeInputProps extends WithStyles<typeof styles> {
  theme: Theme
  component:
    | typeof CardNumberElement
    | typeof CardExpiryElement
    | typeof CardCVCElement
  onFocus: (event: ReactStripeElements.ElementChangeResponse) => void
  onBlur: (event: ReactStripeElements.ElementChangeResponse) => void
  onChange: (event: ReactStripeElements.ElementChangeResponse) => void
}

class StripeInput extends React.PureComponent<IStripeInputProps> {
  public render() {
    const {
      classes,
      theme,
      component: Component,
      onFocus,
      onBlur,
      onChange
    } = this.props

    return (
      <Component
        className={classes.root}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        placeholder=""
        style={{
          base: {
            fontFamily: theme.typography.fontFamily,
            fontSize: '16px',
            color: '#000000de'
          },
          invalid: {
            color: theme.palette.error.main
          }
        }}
      />
    )
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: '6px 0 7px',
      cursor: 'text'
    }
  })

export default withStyles(styles, { withTheme: true })(StripeInput)



// WEBPACK FOOTER //
// ./src/components/stripe-mui/StripeInput.tsx